import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import Link from '@/components_new/Link.vue'
import Typography from '@/components_new/Typography.vue'
import { ROUTE_NAMES } from '@/router/constants'

export default /*@__PURE__*/_defineComponent({
  __name: 'Copyright',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Typography, {
    is: "div",
    type: "paragraph",
    size: "xs"
  }, {
    default: _withCtx(() => [
      _createVNode(Link, {
        to: { name: _unref(ROUTE_NAMES).MAIN },
        color: "white-40"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$tr('navigation.copyright', { year: String(new Date().getFullYear()) })), 1)
        ]),
        _: 1
      }, 8, ["to"])
    ]),
    _: 1
  }))
}
}

})